export const SORT_TYPE = {
  priceAscending: "price-ascending",
  priceDescending: "price-descending",
  reviewDescending: "review-descending",
  reviewAscending: "review-ascending",
  reviewNumAscending: "review-num-ascending",
  reviewNumDescending: "review-num-descending",
};
